(function () {
  'use strict';
  if (window.minetanInitProductGalleries) {
    window.minetanInitProductGalleries();
    return;
  }

  function initGallery(top) {
    if (!top.querySelector('button.swiper-button-prev, button.swiper-button-next')) return;
    var swiper = top.swiper;
    if (!swiper || swiper.destroyed) return;
    var previous = top.minetanGalleryControls;
    if (previous && previous.swiper === swiper) return;
    if (previous) {
      previous.observer.disconnect();
      previous.thumbs.removeEventListener('keydown', previous.keydown);
      previous.thumbs.removeEventListener('click', previous.click, true);
      if (previous.swiper.off) previous.swiper.off('slideChange', previous.update);
    }

    var text = window.minetanGalleryText;
    var container = top.closest('.product-photo-container, .product-img-box') || top.parentElement;
    var thumbs = container.querySelector('.gallery-thumbs');
    var buttons = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll('button.thumb__inner')) : [];
    var next = top.querySelector('.swiper-button-next');
    var prev = top.querySelector('.swiper-button-prev');
    var status = top.querySelector('.product-gallery-status');
    if (!status) {
      status = document.createElement('span');
      status.className = 'product-gallery-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      top.appendChild(status);
    }
    top.setAttribute('role', 'region');
    top.setAttribute('aria-label', text.label);
    if (prev) prev.setAttribute('aria-label', text.previous);
    if (next) next.setAttribute('aria-label', text.next);

    function update() {
      if (swiper.destroyed) return;
      var slides = Array.prototype.slice.call(top.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
      var count = slides.length;
      var index = Number.isInteger(swiper.realIndex) ? swiper.realIndex : swiper.activeIndex;
      index = Math.max(0, Math.min(index, count - 1));
      buttons.forEach(function (button, i) {
        var selected = i === index;
        button.tabIndex = selected ? 0 : -1;
        button.setAttribute('aria-label', text.image.replace('__number__', i + 1));
        if (selected) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
        button.closest('.swiper-slide').classList.toggle('is-selected', selected);
      });
      Array.prototype.forEach.call(top.querySelectorAll('.swiper-slide'), function (slide, i) {
        slide.setAttribute('aria-hidden', String(i !== swiper.activeIndex));
      });
      [[prev, swiper.isBeginning], [next, swiper.isEnd]].forEach(function (entry) {
        if (!entry[0]) return;
        var disabled = count <= 1 || (!swiper.params.loop && entry[1]);
        entry[0].disabled = disabled;
        entry[0].setAttribute('aria-disabled', String(disabled));
      });
      var message = text.position.replace('__current__', index + 1).replace('__total__', count);
      if (count && status.textContent !== message) status.textContent = message;
    }

    // Swiper's legacy clickedIndex is populated by pointer events, not keyboard clicks.
    function click(event) {
      var button = event.target.closest('button.thumb__inner');
      var index = buttons.indexOf(button);
      if (index < 0) return;
      event.preventDefault();
      event.stopPropagation();
      if (swiper.params.loop && typeof swiper.slideToLoop === 'function') swiper.slideToLoop(index, 500, false);
      else swiper.slideTo(index, 500, false);
      if (thumbs.swiper && !thumbs.swiper.destroyed) thumbs.swiper.slideTo(index, 500, false);
      update();
    }

    function keydown(event) {
      var button = event.target.closest('button.thumb__inner');
      if (!button || !buttons.length) return;
      var index = buttons.indexOf(button);
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index++;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index--;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = buttons.length - 1;
      else return;
      event.preventDefault();
      index = (index + buttons.length) % buttons.length;
      buttons[index].click();
      buttons[index].focus({ preventScroll: true });
    }
    if (thumbs) {
      thumbs.addEventListener('keydown', keydown);
      thumbs.addEventListener('click', click, true);
    }
    var observer = new MutationObserver(update);
    observer.observe(top.querySelector('.swiper-wrapper'), {
      subtree: true, attributes: true, attributeFilter: ['class'], childList: true
    });
    swiper.on('slideChange', update);
    top.minetanGalleryControls = { swiper: swiper, observer: observer, thumbs: thumbs || top,
      keydown: keydown, click: click, update: update };
    update();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.gallery-top'), initGallery);
  }
  window.minetanInitProductGalleries = init;
  jQuery(init);
  document.addEventListener('shopify:section:load', function () { window.setTimeout(init, 0); });
})();
